import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

// import Backdrop from './Backdrop';
import './Modal.css';

const ModalOverlay = props => {
  const content = (
    <div ref={props.nodeRef} className={`main-modal ${props.className}`} style={props.style}>
        <div className={`main-modal__content ${props.contentClass}`}>
          {props.children}
        </div>
    </div>
  );
  return ReactDOM.createPortal(content, document.getElementById('main-modal-hook'));
};

const Modal = props => {
  const nodeRef = useRef(null);
  return (
    <React.Fragment>
      {/* {props.show && <Backdrop onClick={props.onCancel} />} */}
      <CSSTransition
        nodeRef={nodeRef}
        in={props.show}
        mountOnEnter
        unmountOnExit
        timeout={200}
        classNames="main-modal"
      >
        <ModalOverlay nodeRef={nodeRef} {...props} />
      </CSSTransition>
    </React.Fragment>
  );
};

export default Modal;
